<template>
    <div class="tep-aupr-grid">
        <ai-grid-edit
            v-if="gridMeta.columns.length"
            ref="gridRef"
            :meta="gridMeta"
            :args='gridArgs'
            :to-remove-toolbar-items-names='removeGridToolbarBtns'
            @user-data-changed='onUserDataChanged'
            @editGridMounted="onEditGridMounted"
            class="tep-aupr-grid"
        />
    </div>
</template>
<script>
export default {
    name: 'tep-aupr-grid',
};
</script>
<script setup>
import { computed, inject, onMounted, ref, watch } from 'vue';
import { getCookie } from '@/utils/cookies';
import tepService from '@/service/tep-service';
import tepCardsStore from '@/views/tep/tep-grid/store/tep-cards-store';

const userData = inject('userData');
const gridRef = ref(null);
const gridArgs = ref(null);
const defaultSaveArgs = ref({kod_sx: -1, dep: +getCookie('dep')});
const gridInstance = ref();
const dataNq = ref(null);
const keyFocus = ref(null);
const dataFieldFocus = ref(null);
const statusSaveButtons = ref(null);

const props = defineProps({
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

onMounted(async () => {
    defaultSaveArgs.value.kod_sx = props?.serverData?.kod;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    if(props?.serverData?.kod) {
        dataNq.value = await tepService.getAuprTipTnData(props?.serverData?.kod);
        await gridRef.value?.setDataSource();
    }
    statusSaveButtons.value = await gridRef.value?.getButtonsRefs();
});

const statusSaveButton = computed( () => {
    const buttonsRefs = statusSaveButtons?.value;
    tepCardsStore.changeStatusSaveButton(buttonsRefs?.value?.isSaveButtonDisabled);
    return buttonsRefs?.value?.isSaveButtonDisabled;
})

const isSaveGrid = computed(() => {
    return tepCardsStore.state.isSaveGrid
})

watch(statusSaveButton, async (newValue) => {
    if(!newValue) {
        userData.value['is_grid_changed'] = Number(!userData.value['is_grid_changed']);
    } else if(newValue) {
        userData.value['is_grid_changed'] = props.serverData['is_grid_changed'];
    }
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
});

watch(isSaveGrid, async (newValue) => {
    if(newValue) {
        await saveGrid();
    }
});

const saveGrid = (async () => {
    const processedData = await gridRef.value?.prepareChangesForSavingFunc();
    const savePromise = await gridRef.value?.save(processedData);
    await tepCardsStore.setSaveGridPromise(savePromise);
    await savePromise;
    await tepCardsStore.changeSavegrid(false);
})


const onEditGridMounted = async () => {
    gridInstance.value = gridRef?.value.gridInstance;
    await gridInstance.value.on('cellClick', onCellClick);
};

const onCellClick = async event => {
    const arrEdit = ['kod_tiptn', 'q2'];
    if(event.column && arrEdit.includes(event.column.dataField)) {
        keyFocus.value = event.key;
        dataFieldFocus.value =event.column.dataField;
    } else {
        keyFocus.value = null;
        dataFieldFocus.value = null;
    }
};

const onUserDataChanged = async (userData) => {
    if(keyFocus.value && dataFieldFocus.value) {
        const dataKeyChanges = userData.changes?.gridChanges.filter(i => i.key === keyFocus.value);
        if(dataKeyChanges.length) {
            const dataGrid = await gridRef.value?.getGridDataSource() ?? [];
            dataKeyChanges.map(item => {
                if(dataFieldFocus.value === 'kod_tiptn') {
                    item.data['q'] = item.data['kod_tiptn'] === 1 ? dataNq.value?.nq_so : dataNq.value?.nq_sw;
                    let q2;
                    if(item.data['q2'] === '') {
                        q2 = '';
                    } else {
                        q2 = item.data['q2'] ? item.data['q2'] : dataGrid.find(i => i.kod === item.key)?.q2;
                    }
                    if(Number(q2) || q2 === '') {
                        item.data['q_b'] = Number(item.data['q']) -  Number(q2);
                    } else {
                        item.data['q_b'] = item.data['kod_tiptn'] === 1 ? dataNq.value?.nq_so : dataNq.value?.nq_sw;
                    }
                }
                if(dataFieldFocus.value === 'q2') {
                    let qN;
                    if(item.data.q === 0) {
                        qN = 0;
                    } else {
                        qN = item.data.q ? item.data.q : dataGrid.find(i => i.kod === item.key)?.q;
                    }
                    item.data['q_b'] = Number(qN) -  Number(item.data['q2']);
                }
            })
        }
    }
};

const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export'];

const gridMeta = {
    "keyExpr": "kod",
    'isFilterPanelVisible': false,
    "columns": [
        {
            'name': 'kod',
            'caption': 'kod',
            'dataField': 'kod',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'nom_akt',
            'caption': '№ акта обследования',
            'dataField': 'nom_akt',
            'allowEditing': true,
            'width':150,
            'index': 2,
            'visible': true,
        },
        {
            'name': 'dat_akt',
            'caption': 'Дата акта обследования',
            'dataField': 'dat_akt',
            'allowEditing': true,
            'width':120,
            'index': 3,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'dat_otkl',
            'caption': 'Дата отключения',
            'dataField': 'dat_otkl',
            'allowEditing': true,
            'width':120,
            'index': 4,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'dat_vkl',
            'caption': 'Дата включения',
            'dataField': 'dat_vkl',
            'allowEditing': true,
            'width':120,
            'index': 5,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'kod_tiptn',
            'caption': 'Вид нагрузки',
            'dataField': 'kod_tiptn',
            'allowEditing': true,
            'width':120,
            'index': 6,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name2"
            },
            "component": {
                "name": "lookup_aupr_tip_tn",
                "id": "kod",
                "text": "name",
                'minHeight': '100px',
            }
        },
        {
            'name': 'q',
            'caption': 'Общая нагрузка (Гкал/час)',
            'dataField': 'q',
            'allowEditing': false,
            'width':120,
            'index': 7,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'q2',
            'caption': 'Отключенная нагрузка (Гкал/час)',
            'dataField': 'q2',
            'allowEditing': true,
            'width':120,
            'index': 8,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'q_b',
            'caption': 'Базовый показатель для расчета (Гкал/час)',
            'dataField': 'q_b',
            'allowEditing': false,
            'width':120,
            'index': 9,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'prim',
            'caption': 'Примечание',
            'dataField': 'prim',
            'allowEditing': true,
            'width':120,
            'index': 10,
            'visible': true,
        },
        {
            'name': 'u_m',
            'caption': 'Пользователь',
            'dataField': 'u_m',
            'allowEditing': false,
            'width':120,
            'index': 11,
            'visible': true,
        },
        {
            'name': 'd_m',
            'caption': 'Дата последних изменений',
            'dataField': 'd_m',
            'allowEditing': false,
            'width': 120,
            'index': 12,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
    ],
    "api": {
        'select': 'tep-grid./tep/qr-aupr-grid/select/get',
        'save': 'tep-grid./tep/qr-aupr-grid/save/set',
    },
    'viewId': 'view-qr-aupr-grid',
}
</script>
<style scoped>
.tep-aupr-grid :deep(.dx-toolbar-item-content .dx-button) {
    background-color: transparent;
}
.tep-aupr-grid :deep(.dx-texteditor.dx-editor-filled) {
    border-radius: 5px;
    min-height: 26px;
}
.tep-aupr-grid :deep(.dx-texteditor-container) {
    border-radius: 5px;
    min-height: 26px;
}
</style>

